import React from 'react';
import { Button } from './Button';
import { Star } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-24 md:pt-32 pb-10 md:pb-16 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto text-center overflow-hidden" data-id="element-55">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] md:w-[1000px] h-[800px] md:h-[1000px] bg-[#00b8ff] opacity-10 rounded-full blur-[150px] -z-10 pointer-events-none" data-id="element-56"></div>

      <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-bold mb-6 md:mb-8 leading-tight text-white" data-id="element-57">
        Desde cero a diagnosticar y reparar{' '}
        <span className="text-[#00b8ff] text-glow-blue" data-id="element-58">tu scooter</span>{' '}
        <span className="text-[#ff2e92] text-glow-pink" data-id="element-59">en 30 min.</span>
      </h1>

      <a href="#comprar" className="block max-w-[70%] sm:max-w-md md:max-w-lg mx-auto mb-6 md:mb-10 transform transition hover:scale-[1.02]" data-id="element-60">
        <img src="https://cdn.magicpatterns.com/uploads/iUFuZ5KLb2Ny7wTraow4Mu/WhatsApp_Image_2026-05-17_at_21.06.20-removebg-preview.png" alt="Mega Kit Scooter" className="w-full h-auto drop-shadow-[0_0_40px_rgba(0,184,255,0.4)]" data-id="element-61" />
      </a>

      <p className="text-base md:text-xl lg:text-2xl text-zinc-300 mb-6 md:mb-8 max-w-4xl mx-auto leading-relaxed" data-id="element-62">
        Recursos avanzados, protocolos técnicos y herramientas profesionales
        para que cualquier persona aprenda a mantener, reparar y monetizar
        scooters (tradicionales y eléctricos) con precisión y autoridad.
      </p>

      <div className="flex items-center justify-center gap-2 mb-2" data-id="element-63">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 md:w-6 md:h-6 fill-yellow-400 text-yellow-400" data-id="element-64" />)}
        <span className="text-white font-bold text-base md:text-lg ml-2" data-id="element-65">
          4.9/5
        </span>
      </div>
      <p className="text-sm md:text-base text-zinc-400 mb-4 md:mb-6" data-id="element-66">
        Elegido por riders y técnicos en toda Argentina
      </p>

      <p className="text-base md:text-lg text-[#00b8ff] font-semibold mb-8 md:mb-10" data-id="element-67">
        El sistema de diagnóstico y reparación de scooters más completo del
        mercado
      </p>

      <Button href="#comprar" className="text-lg md:text-2xl py-4 md:py-5 px-6 md:px-10" data-id="element-68">
        👉 Acceder al Mega Kit Scooter ahora
      </Button>
    </section>;
}